import CustomerService from '@/services/CustomerService'
import NotionService from '@/services/NotionService'

const getAllowedContexts = (app) => app === 'carnot'
  ? ['boucherie', 'carnot']
  : ['poissonnerie', 'hublot']

const normalizeContextValues = (client) => {
  const baseValues = [
    client?.context,
    client?.contexte,
    client?.app,
    client?.environment,
    client?.metier,
    client?.rayon
  ]
  const arrayValues = [
    ...(Array.isArray(client?.contexts) ? client.contexts : []),
    ...(Array.isArray(client?.metiers) ? client.metiers : []),
    ...(Array.isArray(client?.rayons) ? client.rayons : [])
  ]

  return [...baseValues, ...arrayValues]
    .filter(Boolean)
    .map(value => String(value).trim().toLowerCase())
}

const isClientInCurrentContext = (client, app) => {
  const normalizedContexts = normalizeContextValues(client)
  if (!normalizedContexts.length) return true
  const allowedContexts = getAllowedContexts(app)
  return normalizedContexts.some(value => allowedContexts.includes(value))
}

export default {
  state: {
    list: [],
    selected: {},
    notionClients: [],
    selectedNotionClient: {},
    selectedClientContacts: [],
    taskLabels: [],
    addTaskDialog: false,
    taskDescription: '',
    taskOwnerName: '',
    taskSnackbarState: false,
    taskSnackbarMessage: '',
    taskSnackbarColor: '',
    customersAvailableDeviceCapacity: [],
    loader: false,
    progressionValue: 0
  },

  getters: {
    // Logo d'un magasin : son icône Notion, sinon le logo de son enseigne, sinon rien
    shopLogo: state => clientId => {
      const notionClient = state.notionClients.find(client => String(client.clientId) === String(clientId))
      if (notionClient?.notion?.icone) return notionClient.notion.icone
      const shop = state.list.find(customer => String(customer.clientId) === String(clientId))
      return shop?.idenseigne ? CustomerService.getLogo(shop.idenseigne) : ''
    }
  },

  mutations: {
    setDeviceLoader (state, loader) {
      state.loader = loader
    },
    setProgressionValue(state, value) {
      state.progressionValue= value
    },
    setCustomers (state, customers) {
      state.list = customers
    },
    setSelectedCustomer (state, customer) {
      state.selected = customer
    },
    setNotionClients (state, clients) {
      state.notionClients = clients
    },
    setSelectedNotionClient (state, client) {
      state.selectedNotionClient = client
    },
    setSelectedClientContacts (state, contacts) {
      state.selectedClientContacts = contacts
    },
    setTaskLabels (state, labels) {
      state.taskLabels = labels
    },
    setAddTaskDialog (state, bool) {
      state.addTaskDialog = bool
    },
    setTaskDescription (state, text) {
      state.taskDescription = text
    },
    setTaskOwnerName (state, text) {
      state.taskOwnerName = text
    },
    setTaskSnackbarState (state, bool) {
      state.taskSnackbarState = bool
    },
    setTaskSnackbarMessage (state, text) {
      state.taskSnackbarMessage = text
    },
    setTaskSnackbarColor (state, color) {
      state.taskSnackbarColor = color
    },
  },
  actions: {
    setCustomers ({ commit }, customers) {
      commit('setCustomers', customers)
    },
    setSelectedCustomer ({ commit, dispatch }, customer) {
      commit('setSelectedCustomer', customer)
      dispatch('setSmsCount', null, { root: true })
      dispatch('setHomeImages', null, { root: true })
      dispatch('setDatabases', null, { root: true })
    },
    setNotionClients ({ commit }, clients) {
      commit('setNotionClients', clients)
    },
    setSelectedNotionClient ({ commit }, client) {
      commit('setSelectedNotionClient', client)
    },
    setSelectedClientContacts ({ commit }, contacts) {
      commit('setSelectedClientContacts', contacts)
    },
    loadNotionClients({ commit, rootState }, { forceRefresh = false } = {}) {
      const currentApp = rootState?.home?.app || 'hublot'
      return NotionService.getClients(forceRefresh)
        .then(clients => {
          // Le backend est contextuel, mais on applique un filtre défensif pour éviter les mélanges.
          const filteredClients = clients
            .filter(client => client.type === 'Client')
            .filter(client => isClientInCurrentContext(client, currentApp))
          commit('setNotionClients', filteredClients)
          return filteredClients
        })
    },
    setTaskLabels ({ commit }, labels) {
      commit('setTaskLabels', labels)
    },
    setAddTaskDialog ({ commit }, bool) {
      commit('setAddTaskDialog', bool)
    },
    setTaskDescription ({ commit }, text) {
      commit('setTaskDescription', text)
    },
    setTaskOwnerName ({ commit }, text) {
      commit('setTaskOwnerName', text)
    },
    setTaskSnackbarState ({ commit }, bool) {
      commit('setTaskSnackbarState', bool)
    },
    setTaskSnackbarMessage ({ commit }, text) {
      commit('setTaskSnackbarMessage', text)
    },
    setTaskSnackbarColor ({ commit }, color) {
      commit('setTaskSnackbarColor', color)
    },
  }
}
